import CircleClose from '@adv-mt/mt-svg-icons/lib/CircleClose.js'
import LockOutlineIcon from '@adv-mt/mt-svg-icons/lib/LockOutline.js'

export const modalConfig = {
  successfullPayment: {
    notificationType: 'success',
    notificationText: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_SUCCESS.NOTIFICATION_TEXT',
    Icon: LockOutlineIcon,
    description: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_SUCCESS.DESCRIPTION',
    title: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_SUCCESS.TITLE'
  },
  failedPayment: {
    notificationType: 'error',
    notificationText: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_FAILED.NOTIFICATION_TEXT',
    Icon: CircleClose,
    description: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_FAILED.DESCRIPTION',
    title: 'RESERVATION_C2B.MODAL_RESERVATION_PAYMENT_FAILED.TITLE'
  }
}
